import { React, useState, useEffect } from "react";
import styles from "./contactPage.module.css";
import axios from "axios";
import { FaRegPaperPlane } from "react-icons/fa";

const apiUrl = process.env.REACT_APP_URL;

const AuthContactPage = () => {
  /* The Contact Page is used for contacting the website. Both logged in users and guests can use the form to send a message to the website. The sender also gets a confirmation email, with the content of his message. */

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    username: "",
    email: "",
    title: "",
    content: "",
  });

  const [status, setStatus] = useState("notSentYet");

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const res = await axios.get(`${apiUrl}/auth/user`, {
          withCredentials: true,
        });

        if (res.status === 200 && res.data.success) {
          setIsLoggedIn(true);
          const username = res.data.username;

          try {
            const userBasicDetailsRes = await axios.get(
              `${apiUrl}/users/basic/${username}`,
              { withCredentials: true }
            );

            if (
              userBasicDetailsRes.status === 200 &&
              userBasicDetailsRes.data.success
            ) {
              setFormData({
                fullName: `${userBasicDetailsRes.data.firstName} ${userBasicDetailsRes.data.lastName}`,
                username,
                email: userBasicDetailsRes.data.email,
                title: "",
                content: "",
              });
            } else {
              console.error("Error fetching user basic details");
            }
          } catch (error) {
            console.error("Error fetching user basic details", error);
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error("User is not logged in");
        } else {
          console.error("Error checking login status", error);
        }
      }
    };

    checkLoginStatus();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${apiUrl}/contact/incoming/new`, formData);
      if (res.data.success) {
        setStatus("success");
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error submitting form", error);
      setStatus("error");
    }
  };

  return (
    <main className={styles.contactMain}>
      <h1>Contact Us</h1>

      <p>We'd love to hear from you!</p>
      <p>
        Do you have any questions or suggestions, or just want to say hi? Please
        fill in this contact form, and we'll be in touch as soon as possible.
      </p>

      <form className={styles.contactForm} onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label htmlFor="fullName">Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder={isLoggedIn ? "" : "Your full name"}
            disabled={isLoggedIn}
          />
        </div>

        {isLoggedIn && (
          <div className={styles.formGroup}>
            <label htmlFor="username">Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              disabled
            />
          </div>
        )}

        <div className={styles.formGroup}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={isLoggedIn ? "" : "Your email address"}
            disabled={isLoggedIn}
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="title">Topic</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Message Topic"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="content">Your Message</label>
          <textarea
            name="content"
            value={formData.content}
            onChange={handleChange}
            placeholder="Your message..."
            required
          ></textarea>
        </div>

        {status !== "success" && (
          <div className={styles.btnContainer}>
            <button type="submit">
              <span>Send</span> <FaRegPaperPlane />
            </button>
          </div>
        )}
      </form>

      {status === "success" && (
        <div className={styles.feedback}>
          <p>Thanks for reaching out! We will be in touch soon!</p>
        </div>
      )}

      {status === "error" && (
        <div className={styles.feedback}>
          <p>
            Sorry, but we were unable to send your message. Please try again
            later.
          </p>
        </div>
      )}
    </main>
  );
};

export default AuthContactPage;
